import styled from "styled-components"

import {
  Badge,
  IconButton,
  Skeleton,
  spacing,
  Text,
} from "@minuthq/meatball-ui-react"

import { useFetchHome } from "src/data/organizations/queries/homeQueries"
import { TPropertyContext } from "src/data/propertyContext/propertyContextTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { MButton } from "src/ui/Button/MButton"
import TrashIcon from "src/ui/icons/trash.svg"
import { MCard } from "src/ui/MCard/MCard"
import { MMarkdown } from "src/ui/MMarkdown/MMarkdown"

export function AiAssistantSuggestionCard({
  context,
  onAddSuggestion,
  onDeleteSuggestion,
}: {
  context: TPropertyContext
  onAddSuggestion: () => void
  onDeleteSuggestion: () => void
}) {
  const { tPlaceholder } = useTranslate()

  const fetchHome = useFetchHome({
    orgId: context.organization_id,
    homeId: context.home_id ?? "",
    options: {
      enabled: !!context.home_id,
    },
  })

  function renderHome() {
    if (fetchHome.isInitialLoading) {
      return <Skeleton variant="circle" width="10ch" height={18} />
    }

    if (fetchHome.data) {
      return <Badge>{fetchHome.data.name}</Badge>
    }

    return <Badge color="warning">{tPlaceholder("Unknown")}</Badge>
  }

  return (
    <StyledCard border boxShadow={false}>
      <ContentWrapper>
        <Text variant="subtitle">{context.title}</Text>
        <MMarkdown>{context.content}</MMarkdown>

        <PropertyWrapper>
          <Text>{tPlaceholder("Property")}:</Text>

          {renderHome()}
        </PropertyWrapper>
      </ContentWrapper>

      <ButtonWrapper>
        <MButton variant="secondary" size="small" onClick={onAddSuggestion}>
          {tPlaceholder("Apply")}
        </MButton>

        <IconButton
          Icon={TrashIcon}
          size="small"
          variant="subtle"
          onClick={onDeleteSuggestion}
        />
      </ButtonWrapper>
    </StyledCard>
  )
}

const StyledCard = styled(MCard)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${spacing.L};
`

const ContentWrapper = styled.div`
  flex: 1;
  flex-basis: 70%;
  max-width: 70ch;
`

const PropertyWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.XS};

  margin-top: ${spacing.M};
`

const ButtonWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: ${spacing.XS};
`
